import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import colors from '../../../shared/utils/colors';

const ReceivablesByCategoryChart = (props) => {
  const { dataLabels, numbersChart, options } = props;

  const data = {
    labels: dataLabels,
    datasets: [
      {
        data: numbersChart,
        backgroundColor: colors,
        hoverBackgroundColor: ['#9c2dd2', '#D4a3ee'],
        borderColor: 'rgba(255,255,255,0.54)',
      },
    ],
  };

  const legendOptions = {
    display: false,
  };

  return (
    <Doughnut
      height={300}
      data={data}
      legend={legendOptions}
      options={options}
    />
  );
};

ReceivablesByCategoryChart.propTypes = {
  dataLabels: PropTypes.arrayOf(PropTypes.shape),
  numbersChart: PropTypes.arrayOf(PropTypes.shape).isRequired,
  options: PropTypes.shape(PropTypes.shape),
};

ReceivablesByCategoryChart.defaultProps = {
  dataLabels: [],
  options: {},
};

export default withTranslation('common')(ReceivablesByCategoryChart);
